const $j = jQuery.noConflict();

function glsFeedback(msg, color = 'green', elementId = 'feedback') {
  const feedbackSlot = $j(`#${elementId}`);
  let currentFeedback = feedbackSlot.html();

  if (currentFeedback.length !== 0) {
    currentFeedback += '<br />';
  }

  feedbackSlot.html(`${currentFeedback}<span style="color:${color};">${msg}</span>`);
}

function glsFeedbackErr(msg, elementId = 'feedback') {
  glsFeedback(msg, 'red', elementId);
}

function glsFeedbackClear(msg, elementId = 'feedback') {
  $j(`#${elementId}`).html('');
}

export {
  glsFeedbackErr,
  glsFeedback,
  glsFeedbackClear,
};
